import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { PublicClientApplication } from '@azure/msal-browser';
import * as microsoftTeams from '@microsoft/teams-js';
import { isRunningInTeams } from '../shared/utility';
import axios from 'axios';

// MSAL configuration
const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AAD_CLIENT_ID ?? '',
        authority: process.env.REACT_APP_AAD_AUTHORITY ?? '',
        redirectUri: window.origin,
    },
};

export const pca = new PublicClientApplication(msalConfig);

const checkIfRunningInTeams = async (): Promise<boolean> => {
    let inTeams = false;
    try {
        inTeams = Boolean(await isRunningInTeams());
    } catch (error) {
        console.error('Error checking Teams environment:', error);
    }
    return inTeams;
};

export const azureToken = async (scopes: string[]) => {
    const isTeams = await checkIfRunningInTeams();

    if (isTeams) {
        try {
            // Teams app'i initialize et
            await microsoftTeams.app.initialize();

            // Teams SSO token al
            const token = await microsoftTeams.authentication.getAuthToken();
            if (!token || token.trim() === '') {
                throw new Error('Empty token received from Teams');
            }

            // Backend API'ye token gönder ve Graph token al
            const data = { idToken: token };
            const backendUrl = process.env.REACT_APP_BACKEND_URI ?? 'https://localhost:40443/';

            const axiosInstance = axios.create({
                baseURL: backendUrl,
                timeout: 10000,
                headers: {
                    'ngrok-skip-browser-warning': '69420',
                },
            });

            axiosInstance.interceptors.request.use((config) => {
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            });

            try {
                const response = await axiosInstance.post('api/msTeams/GetAccessTokenTeams', data);
                const graphToken = (response.data as { accessTokenGraph: string }).accessTokenGraph;

                if (graphToken) {
                    return graphToken;
                } else {
                    return token;
                }
            } catch (apiError: unknown) {
                // Backend API hatası - SSO token kullan
                return token;
            }
        } catch (error: unknown) {
            console.error('Teams token error:', error);
            throw error;
        }
    } else {
        // Browser ortamı - MSAL kullan
        const accounts = pca.getAllAccounts();
        if (accounts.length === 0) {
            return '';
        }

        const account = accounts[0];
        const tokenRequest = {
            scopes: scopes,
            account: account,
        };

        try {
            const response = await pca.acquireTokenSilent(tokenRequest);
            return response.accessToken;
        } catch (error: unknown) {
            if (error instanceof InteractionRequiredAuthError) {
                return pca
                    .acquireTokenPopup(tokenRequest)
                    .then((response) => {
                        return response.accessToken;
                    })
                    .catch((popupError: unknown) => {
                        console.error('Popup token error:', popupError);
                        throw popupError;
                    });
            } else {
                console.error('MSAL token error:', error);
                throw error;
            }
        }
    }
};
